<script setup>
import moment from "moment";
</script>
<template>
  <div class="p-4" id="elementPrint">
    <div class="p-4" id="page1">
      <!-- <img src="../../../assets/images/borneo-indobara-icon.png" alt="" style="width: 15%;height: auto"> -->
      <h1
        class="text-center mb-3 judul"
        style="font-family: 'Inter-Bold'"
        id=""
      >
        Certificate of CMS Compliance
      </h1>
      <p class="text-center fs-8 mb-3" style="font-family: 'Inter-Regular'">
        Nomor Registrasi : {{ nomorRegistrasi }}
      </p>
      <div class="row mb-3">
        <div class="col-md-12">
          <p class="fs-8">
            Berdasarkan Elemen Standar BIB-HSE-ES-2.09 tentang Pengelolaan
            Perusahaan Jasa Pertambangan, PT Borneo Indobara menerbitkan
            Certificate of CMS Compliance (CoC) kepada :
          </p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <ol type="1" class="fs-8" style="font-family: 'Inter-Regular'">
            <li>Nama Perusahaan Jasa : {{ kontraktor.namaKontraktor }}</li>
            <li>Kategori Perusahaan : {{ kontraktor.wilayah }}</li>
            <li>Klasifikasi Perusahaan Jasa : {{ kontraktor.jenis }}</li>
            <li>
              Kualifikasi Perusahaan Jasa :
              {{
                kontraktor.kualifikasiUsaha == null
                  ? "-"
                  : kontraktor.kualifikasiUsaha
              }}
            </li>
            <li>Kode Klasifikasi Usaha : Lihat Lampiran</li>
          </ol>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <p class="fs-8">
            Perusahaan Jasa Pertambangan dengan nomor registrasi CoC tersebut
            dapat melakukan persiapan dan/atau pelaksanaan kegiatan berusaha
            sebagaimana terlampir dengan tetap memperhatikan ketentuan peraturan
            perundang-undangan dan persyaratan lainnya yang berlaku di wilayah
            operasional PT Borneo Indobara.
          </p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <p class="fs-8">
            CoC ini berlaku di seluruh wilayah operasional PT Borneo Indobara
            dengan masa berlaku 2 tahun sejak tanggal diterbitkan. Perusahaan
            Jasa Pertambangan dapat mengajukan perpanjangan dan/atau pembaharuan
            CoC sesuai dengan ketentuan peraturan yang berlaku di PT Borneo
            Indobara.
          </p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <p class="fs-8">Diterbitkan di Angsana, tanggal : 11 Desember 2022</p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <p class="fs-8">(Perubahan ke-0)</p>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-9">&nbsp;</div>
        <div class="col-md-3 text-center">
          <p class="mb-1 fs-8">
            {{
              dataSio?.updatedAt
                ? getKepalaTeknikTambangTitle(new Date(dataSio?.updatedAt))
                : "Kepala Teknik Tambang"
            }}
          </p>
          <p class="mb-2 fs-8">PT Borneo Indobara</p>
          <div class="w-100 border border-1 mb-1" style="height: 10vh"></div>
          <p class="fs-8">
            {{
              dataSio?.updatedAt
                ? getKepalaTeknikTambangName(new Date(dataSio?.updatedAt))
                : "-"
            }}
          </p>
        </div>
      </div>
      <div class="row footer" style="">
        <div class="col-md-12">
          <ul type="1" class="fs-8" style="font-family: 'Inter-Regular'">
            <li>Dokumen ini diterbitkan melalui Aplikasi SINI-SAJA</li>
            <li>
              Dalam hal terjadi kekeliruan isi dokumen ini akan dilakukan
              perbaikan sebagaimana mestinya
            </li>
            <li>
              Pengajuan perpanjangan atau pembaharuan CoC diajukan melalui
              Aplikasi SINI-SAJA
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="p-4">
      <h1 class="text-center mb-3 judul" style="font-family: 'Inter-Bold'">
        LAMPIRAN Certificate of CMS Compliance
      </h1>
      <p class="text-center fs-8 mb-3" style="font-family: 'Inter-Regular'">
        Nomor Registrasi : {{ nomorRegistrasi }}
      </p>
      <div class="row mb-5">
        <div class="col-md-12">
          <p class="fs-8 judul_table">
            Bidang Usaha Jasa Inti (memiliki kode KBLI 09900 – Aktivitas
            Penunjang Pertambangan dan Penggalian Lainnya)
          </p>
          <div class="">
            <table
              class="table table-striped mb-0"
              style="width: 100%; font-family: 'Inter-Regular'"
            >
              <thead
                style="
                  font-family: 'Inter-Regular';
                  font-style: normal;
                  font-weight: 500;
                  font-size: 14px;
                  color: #28293d;
                "
              >
                <tr class="table-danger" style="max-height: 5vh">
                  <th class="p-2" style="width: 5%">No.</th>
                  <th class="p-2 pointer text-nowrap" style="width: 20%">
                    Kode KBLI
                  </th>
                  <th class="p-2 pointer text-nowrap" style="width: 15%">
                    Bidang
                  </th>
                  <th class="p-2 pointer text-nowrap" style="width: 40%">
                    Sub-Bidang
                  </th>
                  <th class="p-2 pointer text-nowrap" style="width: 20%">
                    Tingkat Resiko
                  </th>
                </tr>
              </thead>
              <tbody
                id="tbody_table_bidang"
                style="
                  font-family: 'Inter-Regular';
                  font-style: normal;
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 24px;
                  color: #28293d;
                "
              >
                <tr v-for="(bid, idx) in bidang" :key="idx">
                  <td>
                    {{ idx + 1 }}
                  </td>
                  <td class="text-nowrap">09900</td>
                  <td class="text-wrap">{{ bid.bidang }}</td>
                  <td class="text-wrap">{{ bid.subBidang }}</td>
                  <td class="text-wrap">Tinggi</td>
                </tr>
                <tr v-if="!bidang.length">
                  <td colspan="5" class="text-center">Tidak ada data Bidang</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-md-12">
          <p class="fs-8 judul_table">Bidang Usaha Jasa Non-Inti</p>
          <div class="table-responsive">
            <table
              class="table table-striped mb-0"
              style="width: 100%; font-family: 'Inter-Regular'"
            >
              <thead
                style="
                  font-family: 'Inter-Regular';
                  font-style: normal;
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 24px;
                  color: #28293d;
                "
              >
                <tr class="table-danger" style="max-height: 5vh">
                  <th class="p-2" style="width: 5%">No.</th>
                  <th class="p-2 pointer text-nowrap" style="width: 20%">
                    Kode KBLI
                  </th>
                  <th class="p-2 pointer text-nowrap" style="width: 40%">
                    Judul KBLI
                  </th>
                  <th class="p-2 pointer text-nowrap" style="width: 20%">
                    Tingkat Resiko
                  </th>
                  <th class="p-2 pointer text-nowrap" style="width: 40%">
                    Kelompok Usaha
                  </th>
                  <th class="p-2 pointer text-nowrap" style="width: 15%">
                    Keterangan
                  </th>
                </tr>
              </thead>
              <tbody
                id="tbody_table_kbli"
                style="
                  font-family: 'Inter-Regular';
                  font-style: normal;
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 24px;
                  color: #28293d;
                "
              >
                <tr v-for="(kb, idx) in kbli" :key="idx">
                  <td>
                    {{ idx + 1 }}
                  </td>
                  <td class="text-wrap">{{ kb.noKbli }}</td>
                  <td class="text-wrap">{{ kb.deskripsi }}</td>
                  <td class="text-wrap">
                    <span v-if="kb.tingkatResiko == 1">Rendah</span>
                    <span v-if="kb.tingkatResiko == 2">Menengah Rendah</span>
                    <span v-if="kb.tingkatResiko == 3">Menengah Tinggi</span>
                    <span v-if="kb.tingkatResiko == 4">Tinggi </span>
                  </td>
                  <td class="text-wrap">{{ kb.deskripsiMaster }}</td>
                  <td class="text-wrap">
                    <img
                      src="@/assets/icons/verified.png"
                      alt=""
                      style="width: 75%; height: auto; margin-top: 0px"
                    />
                  </td>
                </tr>
                <tr v-if="!kbli.length">
                  <td colspan="6" class="text-center">Tidak ada data Bidang</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-md-12">
          <ul
            type="1"
            class="fs-8"
            style="font-family: 'Inter-Regular'"
            id="div_syarat"
          >
            <li>
              Syarat dan Ketentuan :
              <ol type="a" class="fs-8" style="font-family: 'Inter-Regular'">
                <li>
                  Masa berlaku CoC selama 2 tahun sejak tanggal diterbitkan
                </li>
                <li>CoC dapat diajukan pembaharuani dengan kondisi :</li>
                <li>Masa belaku telah habis</li>
                <li>
                  Terdapat pembaharuan profile perusahaan seperti pembaharuan:
                  <ul
                    type="1"
                    class="fs-8"
                    style="font-family: 'Inter-Regular'"
                  >
                    <li>Nama Perusahaan</li>
                    <li>Kategori Perusahaan</li>
                    <li>Klasifikasi Perusahaan</li>
                    <li>Kualifikasi Perusahaan</li>
                    <li>Kode Klasifikasi Perusahaan</li>
                  </ul>
                </li>
                <li>
                  Apabila kode KBLI memiliki kolom resktriksi yang berisi
                  keterangan “Persiapan”, maka perusahaan jasa hanya
                  diperbolehkan melakukan tahapan persiapan pekerjaan sebatas
                  melakukan pengajuan calon Penanggung Jawab Operasional (PJO)
                  atau Penanggung Jawab Pekerjaan (PJK) dan tidak diperbolehkan
                  melakukan kegiatan operasional.
                </li>
                <li id="poin_f">
                  Kepala Teknik Tambang berhak melakukan pencabutan CoC jika
                  perusahaan jasa melakukan pelanggaran terhadap persyaratan dan
                  ketentuan yang berlaku di area operasional PT Borneo Indobara
                </li>
              </ol>
            </li>
          </ul>
        </div>
      </div>
      <div class="row footer">
        <div class="col-md-12">
          <ul type="1" class="fs-8" style="font-family: 'Inter-Regular'">
            <li>Dokumen ini diterbitkan melalui Aplikasi SINI-SAJA</li>
            <li>
              Dalam hal terjadi kekeliruan isi dokumen ini akan dilakukan
              perbaikan sebagaimana mestinya
            </li>
            <li>
              Pengajuan perpanjangan atau pembaharuan CoC diajukan melalui
              Aplikasi SINI-SAJA
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import router from "../router";
// import SidebarComponent from '@/components/SideBar.vue';
// import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../../GlobalDataMixin";
// import Datepicker from "vuejs3-datepicker"
import axios from "axios";
import Swal from "sweetalert2";
import {
  API_BASE_URL,
  CMS_GET_DETAILKONTRAKTOR,
  // CMS_VIEW_IMAGE,
  CMS_GET_SIOID,
  // CMS_SET_SIOID
} from "@/constants";
//import Swal from "sweetalert2"
import printJS from "print-js";
import {
  getKepalaTeknikTambangName,
  getKepalaTeknikTambangTitle,
} from "@/config/tempKepalaTeknikTambang";

const url_get_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;

const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
// const url_set_sioid = API_BASE_URL + CMS_SET_SIOID;
const url_detail_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR;

export default {
  mixins: [GlobalDataMixin],
  name: "lihatDokumenSIO",
  // components: {
  //   FontAwesomeIcon,
  //   SidebarComponent
  // },
  data() {
    return {
      isPrint: false,
      isLoading: true,
      sioID: null,
      kontraktorName: null,
      kontraktorid: null,
      id: null,
      formValues: {
        namaPemimpin: "",
        jabatanPemimpin: "",
        nama: "",
        perusahaan: "",
        jabatan: "",
        kompetensi: "",
        noSertifikat: "",
        pjo: "",
        tempat: "",
        tanggal: moment(new Date()).format("YYYY-MM-DD"),
        tandaTangan: "",
        namaTTD: "",
        ttd: "",
      },
      kontraktor: [],
      bidang: [],
      kbli: [],
      dataSio: [],
      nomorRegistrasi: "",
    };
  },
  mounted() {
    this.sioID = this.$route.params.id;
    this.kontraktorid = this.$route.params.kontraktorid;
    this.getSioID(this.kontraktorid);
    this.fetchDataKontraktor(this.kontraktorid);
  },
  methods: {
    getKepalaTeknikTambangName,
    getKepalaTeknikTambangTitle,
    getKontraktor(id) {
      axios
        .get(url_get_kontraktor + id, {
          headers: { accept: "application/json" },
        })
        .then((response) => {
          console.log(response);
          this.kontraktor = response.data.detailKontraktor;
          // set value form edit
          // this.url_icon = API_BASE_URL+CMS_VIEW_IMAGE+response.data.detailKontraktor.image;
          if (
            response.data.detailKontraktor.image != null ||
            response.data.detailKontraktor.image != ""
          ) {
            localStorage.setItem(
              "icon_kontraktor_cms",
              JSON.stringify({ icon: response.data.detailKontraktor.image }),
            );
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data Detail Kontraktor : " + error.message);
          console.error("Error fetching data:", error.message);
        });
    },

    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response nya = ", response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let dt = null;
          dt = response.data.data;
          if (dt != null) {
            this.dataSio = dt;
            this.sioID = dt.id;

            let id = "";
            if (dt.id < 10) {
              id = "00" + dt.id;
            } else if (dt.id < 100) {
              id = "0" + dt.id;
            } else {
              id = dt.id;
            }

            this.nomorRegistrasi = "BIB-CoC-A-" + id;
            // localStorage.setItem('sio_cms',JSON.stringify({'id':dt.id}));
            // this.getSioDashboard(this.sioID);
            this.status = dt.status;
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    async fetchDataKontraktor(id) {
      axios
        .get(url_detail_kontraktor + id)
        .then((response) => {
          console.log(response.data.detailKontraktor);
          this.kontraktor = response.data.detailKontraktor;

          this.kontraktorName = response.data.detailKontraktor.namaKontraktor;
          var arr_kbli = [];

          let dtkb = response.data.dataKbli;
          for (var kk in dtkb) {
            if (dtkb[kk].noKbli != "09900" && dtkb[kk].noKbli != "9900") {
              arr_kbli.push(dtkb[kk]);
            }
          }
          this.kbli = arr_kbli;

          var arr_bid = [];
          var abd = [];
          var asbd = [];
          var temp_key = "";
          var b = 0;
          var sb = 1;
          for (var key in this.kontraktor.bidang) {
            var subi = this.kontraktor.bidang[key];
            if (temp_key != key) {
              temp_key = key;
              b += 1;
              sb = 1;
            }
            abd.push(b + ". " + key);

            for (var xx in subi) {
              if (
                key != "" &&
                key != null &&
                subi[xx] != "" &&
                subi[xx] != null
              ) {
                arr_bid.push({
                  bidang: key,
                  subBidang: subi[xx],
                });
              }
              asbd.push(b + "." + sb + ". " + subi[xx]);
              sb++;
            }
          }
          this.bidang = arr_bid;
          console.log("kbli", this.kbli);
          console.log("bidang", this.bidang);

          this.$nextTick(function () {
            // DOM is now updated
            // `this` is bound to the current instance
            this.print();
          });

          // setTimeout(this.print(),2000);
        })
        .catch((error) => {
          alert("Error Fetch Data List Kontraktor : " + error.message);
          console.error("Error fetching data:", error);
        });
    },
    async print() {
      printJS({
        printable: "elementPrint", // ID of the element you want to print
        // printable : ['elementPrint1','elementPrint2'],
        type: "html", // 'html' or 'image'
        // header: 'Print Preview', // optional
        documentTitle: "DokumenSIO", // optional
        font_size: "",
        // style:url_css
        style: `
          @media print {
            * {
                -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
                color-adjust: exact !important;                 /* Firefox 48 – 96 */
                print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
            }
            @page {
              size: A4; /* Set the paper size to A4 */
              // margin: 0; /* Remove default page margins */
            }
            #elementPrint {
              transform: scale(1.1); /* Set the default scale to 0.8 */
              transform-origin: top left; /* Set the transformation origin */
              font-family: Inter-Regular;
            }
            #page1{
              margin-bottom: 70vh;
            }
            .text-center {text-align: center!important;}
            .fs-8 {font-size: 1rem !important;}
            p {margin-top: 0;margin-bottom: 2rem;}
            h1 {font-size: 2.5rem;}
            .mb-3 {margin-bottom: 1rem!important;}
            ol, ul {padding-left: 1rem;}
            .footer{
              margin-top:15rem;
            }
            li {display: list-item; margin-bottom 1rem}
            #div_syarat{
              margin-top:3rem;
            }
            #poin_f, .mt-135{
              margin-top:1.35rem;
            }
            .judul_table{
              margin-bottom:1rem;
            }
            .p-4 {padding: 1.5rem!important;}
            .mb-5 {margin-bottom: 3rem !important;}

            .table, .table tr th, .table tr td{
              border:0.25px #000000 solid;
              // background-color : #f8d7da;
              
            }
            .table tr th{
              background-color : #f8d7da;
            }
            .table tr td{
              padding-left:0.5rem;
            }
          }
        `,
      });
    },
    printSIO() {
      this.isPrint = true;
      // this.isLoading = true;
      this.print();
      // setTimeout(this.print(),2000)
      // this.isLoading = true;
      // let bodyJson = {
      //   kontraktorId: this.clicked.kontraktorId,
      //   action: "publish-sio",
      //   id: this.clicked.idSio
      // }
      // axios
      //     .post(url_set_sioid, bodyJson, {
      //       headers: {
      //         role:'isafe',
      //         Authorization: "Bearer " + this.userData.token,
      //         accept: "application/json",
      //       },
      //     })
      //     .then((response) => {

      //       console.log("response terbitSIO : ", response)
      //       this.alertSuksesTerbitSio()
      //       this.isLoading = false;
      //     })
      //     .catch((error) => {
      //       this.isLoading = false;
      //       console.log("error terbitSIO : ", error)
      //       alert("error terbitSIO")
      //     })
      //     .then(() => {})
    },
    alertSuksesTerbitSio() {
      Swal.fire({
        title: "Proses Pengajuan CoC",
        text: "CoC Berhasil Diterbitkan!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$refs.closeModal.click();
        // this.$router.back()
        this.$router.go();
      });
    },
    printDokumen() {
      const printableContent = document.getElementById("templatex");
      const printWindow = window.open("", "_blank");

      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Dokumen CoC</title>
              <style>
                /* Add your print styles here */
                body {
                  font-family: Inter-Regular;
                }
              </style>
            </head>
            <body>
              ${printableContent.innerHTML}
            </body>
          </html>
        `);

        printWindow.document.close();
        printWindow.print();
      } else {
        console.error("Failed to open print window.");
      }
    },
  },
};
</script>

<style scoped>
/* h1{
    font-size: 5rem;
    color:red,
}

.judul{
    font-size: 5rem;
    color:blue,
}

p{
    color:red;
} */

section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}

.btn_eform {
  background-color: #fff;
  border: #d0d5dd;
}
</style>
